import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Button from "../../../ui/Button";
import ResetIcon from "../../../ui/icons/ResetIcon";
import WarningIcon from "../../../ui/icons/WarningIcon";
import { setViewerOrientation } from "../../CreateTPlan_2SegMRI/actions";
import { CapsuleRiskScoresFailureScreenText } from "../constants";
import { sceneOrientations } from "../../../constants";

function CapsuleRiskMapFailureScreen(props) {
    const dispatch = useDispatch();

    const isAxial = props.viewerOrientation === sceneOrientations.AXIAL;

    return (
        <div className="flex h-full w-full flex-col items-center gap-2 px-14 pt-4">
            {isAxial && <WarningIcon size="50" />}
            <div className="font-medium">
                {isAxial
                    ? CapsuleRiskScoresFailureScreenText.HEADING
                    : CapsuleRiskScoresFailureScreenText.HEADING_NON_AXIAL}
            </div>
            <div className="flex w-full flex-col items-center text-center">
                {isAxial
                    ? CapsuleRiskScoresFailureScreenText.SUB_HEADING
                    : CapsuleRiskScoresFailureScreenText.SUB_HEADING_NON_AXIAL}
                {!isAxial && (
                    <Button
                        className="mt-2 gap-3 px-4"
                        customHeight="h-10"
                        onClick={() =>
                            dispatch(
                                setViewerOrientation(sceneOrientations.AXIAL)
                            )
                        }
                    >
                        Reset to Axial
                        <ResetIcon size="20" />
                    </Button>
                )}
            </div>
        </div>
    );
}

CapsuleRiskMapFailureScreen.propTypes = {
    viewerOrientation: PropTypes.string,
};

export default CapsuleRiskMapFailureScreen;
